import request from "@/api/request";

/**
 * 1. 批量填报分包付款计划
 */
export function batchSaveSubpackagePaymentPlan(data) {
  return request({
    url: "/finance-service/subcontract-payment-plan/batch-save",
    method: "post",
    data,
  });
}

/**
 * 2. 实时计算分包付款金额
 */
export function calculatePaymentAmount(params) {
  return request({
    url: "/finance-service/subcontract-payment-plan/calculate",
    method: "get",
    params,
  });
}

/**
 * 3. 生成回款记录JSON
 */
export function generateCollectionJson(params) {
  return request({
    url: "/finance-service/subcontract-payment-plan/generate-collection-json",
    method: "get",
    params,
  });
}

/**
 * 4. 查询所有部门某一周的分包付款计划
 * @param {Object} params 周相关参数
 */
export function getListAllWeek(params) {
  return request({
    url: "/finance-service/subcontract-payment-plan/list-all-week",
    method: "get",
    params,
  });
}

/**
 * 4. 查询当前部门某一周的分包付款计划
 * @param {Object} params 周相关参数
 */
export function getDeptWeekPlan(params) {
  return request({
    url: "/finance-service/subcontract-payment-plan/list-by-dept-week",
    method: "get",
    params,
  });
}

/**
 * 5. 月度分包付款统计
 */
export function getMonthlyStatistics(params) {
  return request({
    url: "/finance-service/subcontract-payment-plan/monthly-statistics",
    method: "get",
    params,
  });
}

/**
 * 6. 手动触发刷新当前周分包付款计划数据
 */
export function refreshCurrentWeekPlan() {
  return request({
    url: "/finance-service/subcontract-payment-plan/refresh-current-week",
    method: "post",
  });
}

/**
 * 7. 获取月度周信息
 */
export function getWeeks(yearMonth) {
  return request({
    url: "/finance-service/project-payment-plan/get-weeks",
    method: "get",
    params: { yearMonth },
  });
}